import service from '@/utils/server';

const modName='/md/shipTo/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName+'pageInfo',
    method: 'post',
    data
  })
};

//导出文件方法
export const getExportData = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/shipTo/api/index.js